import React, { forwardRef, useEffect, useState } from "react";
import { TextField, Autocomplete, CircularProgress } from "@mui/material";
import { factory } from "../../api/apiFactory";

const citiesApi = factory.get("cities");

export const SelectCity = forwardRef((props, ref) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const fetchCities = (search = "") => {
    setLoading(true);
    const params = {
      skip: 0,
      take: 40,
    };
    if (props.province_id) {
      params.province_id = props.province_id;
    }
    if (search) {
      params.search = search;
    }
    citiesApi.index(params).then((res) => {
      setOptions(res.data.data);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (props.province_id) {
      fetchCities();
    }
  }, [props.province_id]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      fetchCities(search);
    }, 500);
    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <Autocomplete
      ref={ref}
      options={options}
      {...props}
      getOptionLabel={(option) => `${option.name_en} - ${option.name_ar}`}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label={!props.label ? "City" : props.label}
          error={props.error ? props.error : null}
          helperText={props.helperText ? props.helperText : null}
          onChange={(e, value) => {
            setSearch(e.target.value);
          }}
          required={props.required}
          size="small"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
});
